import { PencilIcon } from "@heroicons/react/24/outline";

import { DropdownMenuItem } from "@fronterahealth/frontera-ui-components/ui/dropdown-menu";

import { ReviewItemFieldsFragment } from "@api/graphql/types-and-hooks";
import { useReviewSession } from "@components/QaReview/hooks/useReviewSession";

interface CommentActionEditProps {
  comment: ReviewItemFieldsFragment;
}

export const CommentActionEdit: React.FC<CommentActionEditProps> = ({ comment }) => {
  const { dispatch } = useReviewSession();

  return (
    <DropdownMenuItem
      onClick={(e) => {
        e.stopPropagation();
        dispatch({ type: "startEditing", commentId: comment.id });
      }}
    >
      <PencilIcon />
      Edit
    </DropdownMenuItem>
  );
};
